import React from 'react'
import styled from 'styled-components'
import moment from 'moment'
import PropTypes from 'prop-types'
import PaneHeaderYear from './PaneHeaderYear'
import RemoveInterimModal from './RemoveInterimModal'
import Modal from '../common/Modal'
import findDiffs from './helpers/findDiffs'
import 'react-dates/initialize'

const Container = styled.div`
  display: grid;
  grid-template-columns: 3fr 1fr 1fr 1fr 1fr 1fr;
  padding: 10px 10px 10px 0px;
`
const Button = styled.button`
  border-radius: 3px;
  margin: 0 5px 5px 15px;
  display: inline-block;
  color: white;
  cursor: pointer;
  padding: 5px 20px;
  border: none;
  background: #dd6a01;
`
const ButtonContainer = styled.div`
`
export default class PaneHeader extends React.Component {
  constructor() {
    super()
    this.state = {
      isRemoveModalOpen: false,
      yearToBeRemoved: 0
    }
  }

  getFiscalYearStartDate = year => {
    const { fiscalYearEndDate } = this.props
    const date = moment(fiscalYearEndDate, 'MMDDYYYY')
    date.add(1, 'd').year(year)
    return date
  }

  getPnLEndDate = year => {
    // TODO: Perhaps this logic should exist in PLDatePicker or PaneHeaderYear?
    const { entity } = this.props
    const { interimPeriods, fiscalYears } = entity
    const fiscalYearStartDate = this.getFiscalYearStartDate(year)
    const fiscalYear = fiscalYears.find(fy => fy.year === year)
    let pAndLEndDate
    if (fiscalYear) {
      // We subtract one day because moment considers there to be 365 days between
      // the same day of the current and next year (ex. 365 days between Jan 1 2017 and
      // Jan 1 2018). In order to correct this, we subtract one day.
      pAndLEndDate = fiscalYearStartDate.clone().add(fiscalYear.days - 1, 'd')
    } else if (interimPeriods && interimPeriods.some(period => period.year === year)) {
      const interimEnd = interimPeriods.find(period => period.year === year).to.replace(',', '')
      pAndLEndDate = moment(interimEnd, 'MMMM DD YYYY').year(year)
    } else {
      pAndLEndDate = moment().add(1, 'd')
    }
    return pAndLEndDate
  }

  toggleRemoveInterimModal = (year = 0) => {
    const { isRemoveModalOpen } = this.state
    this.setState({
      isRemoveModalOpen: !isRemoveModalOpen,
      yearToBeRemoved: year
    })
  }

  renderYears = () => {
    const {
      onFormOptionsChange,
      years,
      isEditable,
      data,
      resourceType,
      pAndLUrls,
      interimYears,
      refetch,
      entity,
      changeYearSource,
      yearSources,
      cashflowOptions,
      loanId,
      loan,
      queriedYears,
      resetYearSources
    } = this.props
    const { financialReviewSegments, fiscalYears } = entity
    const allCategories = financialReviewSegments.reduce((acc, segment) => acc.concat(segment.categories), [])
    const nonDerivedCategories = {}
    for (const category of allCategories) {
      if (!category.derived) {
        nonDerivedCategories[category.key] = true
      }
    }
    return Array.from(years.keys()).map(year => {
      const { taxReturn, period } = years.get(year)
      const fiscalYear = fiscalYears.slice().find(fy => fy.year === year)
      const isAveraged = period === 'interim' && resourceType === 'Guarantor' && fiscalYear.period === 'interim'
      const hasDiscrepancy = findDiffs(data, fiscalYears).filter(diff => diff.year === year && diff.discrepancy).length > 0
      const fiscalYearStartDate = this.getFiscalYearStartDate(year)
      let pLUrl = null
      if (resourceType === 'Business' && interimYears) {
        const urlObj = pAndLUrls.find(obj => parseInt(obj.label, 10) === year)
        pLUrl = urlObj ? urlObj.value : null
      }
      return (
        <PaneHeaderYear
          onFormOptionsChange={onFormOptionsChange}
          isEditable={isEditable}
          data={data}
          fiscalYearStartDate={fiscalYearStartDate}
          pAndLEndDate={this.getPnLEndDate(year)}
          resourceType={resourceType}
          taxReturn={taxReturn}
          period={fiscalYear.period}
          pLUrl={pLUrl}
          isAveraged={isAveraged}
          hasDiscrepancy={hasDiscrepancy}
          fiscalYear={fiscalYear}
          year={year}
          key={`pane-header-${year}`}
          refetch={refetch}
          entityId={entity.rid}
          isLastInterim={interimYears && interimYears[interimYears.length - 1] === year}
          changeYearSource={changeYearSource}
          yearSources={yearSources}
          entity={entity}
          cashflowOptions={cashflowOptions}
          loanId={loanId}
          loan={loan}
          queriedYears={queriedYears}
          toggleRemoveInterimModal={() => this.toggleRemoveInterimModal(year)}
          resetYearSources={resetYearSources}
        />
      )
    })
  }

  renderButton = () => {
    const { isEditable, toggleEdit, isEditAllowed } = this.props
    if (isEditAllowed) {
      return <Button id="edit" onClick={toggleEdit}>{isEditable ? 'Save' : 'Enter Spreads'}</Button>
    }
  }

  renderRemoveInterimModal = () => {
    const { loan, loanId, cashflowOptions, refetch, queriedYears, resetYearSources } = this.props
    const { isRemoveModalOpen, yearToBeRemoved } = this.state
    return (
      <Modal light isModalOpen={isRemoveModalOpen}>
        <RemoveInterimModal
          onCancel={() => this.toggleRemoveInterimModal()}
          loan={loan}
          loanId={loanId}
          cashflowOptions={cashflowOptions}
          year={yearToBeRemoved}
          refetch={refetch}
          queriedYears={queriedYears}
          resetYearSources={resetYearSources}
        />
      </Modal>
    )
  }

  render() {
    return (
      <Container id="pane_header">
        <ButtonContainer>
          {this.renderButton()}
        </ButtonContainer>
        {this.renderYears()}
        {this.renderRemoveInterimModal()}
      </Container>
    )
  }
}

PaneHeader.propTypes = {
  years: PropTypes.object,
  isEditable: PropTypes.bool,
  toggleEdit: PropTypes.func
}
